/* eslint-disable @typescript-eslint/member-ordering */

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UserDto } from 'src/app/api/platform';
import { DeleteUserModalComponent } from 'src/app/modals/delete-user-modal/delete-user-modal.component';
import { UsersService } from 'src/app/services/users.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-delete-user',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
  styleUrl: './delete-user.component.scss',
  templateUrl: './delete-user.component.html',
})
export class DeleteUserComponent {
  public usersService: UsersService = inject(UsersService);
  public modalService: NgbModal = inject(NgbModal);
  public toastr: ToastrService = inject(ToastrService);

  deleteUserModel = false;

  public async findUser(identifier: string) {
    // eslint-disable-next-line sonarjs/deprecation
    this.usersService.getUserModel(identifier).subscribe(
      (response: UserDto) => {
        if (response) {
          const modal = this.modalService.open(DeleteUserModalComponent, {
            ariaLabelledBy: 'modal-basic-title',
            backdrop: 'static',
            centered: true,
            size: 'xl',
            windowClass: 'dark-modal ltr',
          });
          modal.componentInstance.userModel.set(response);
        }
      },
      (err) => {
        this.toastr.error('User not found', err);
      }
    );
  }
}
